import { Component, OnInit } from '@angular/core';

import { RoutingService, TranslatePipe } from '@spartacus/core';
import { UserAccountService } from '@spartacus/user/account/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { CartQuoteSummary } from 'src/app/models/cart-quote-summary.model';
import { KnBrCartQuoteSummaryComponent } from 'src/app/sales-libs/kn-br-home/components/kn-br-cart-quote-summary/kn-br-cart-quote-summary.component';
import { KnBrCartQuoteSummaryService } from 'src/app/services/kn-br-cart-quote.service';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-cart-quote-summary',
    templateUrl: './sloan-cart-quote-summary.component.html',
    imports: [AsyncPipe, TranslatePipe]
})
export class SloanCartQuoteSummaryComponent extends KnBrCartQuoteSummaryComponent implements OnInit {
  openCartsCount$: Observable<CartQuoteSummary[]> = this.cartQuoteSummaryService.loadCartsCounter();
  cartsValue$: Observable<CartQuoteSummary[]> = this.cartQuoteSummaryService.loadCartsValue();
  quotesCount$: Observable<CartQuoteSummary[]> = this.cartQuoteSummaryService.loadQuotesCounter();
  quotesValue$: Observable<CartQuoteSummary[]> = this.cartQuoteSummaryService.loadQuotesValue();
  subscription: Subscription;

  constructor(
    protected cartQuoteSummaryService: KnBrCartQuoteSummaryService,
    protected routingService: RoutingService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected userService: UserAccountService
  ) {
    super(cartQuoteSummaryService, routingService, knBrCustomerContextService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
    combineLatest([this.userService.get(), this.knBrCustomerContextService.getActiveCustomerNumber()]).subscribe(
      ([user, customerNumber]) => {
        if ((user && user.roles) || (user && user.roles === undefined)) {
          this.cartQuoteSummaryService.getCartsCounter(customerNumber);
          this.cartQuoteSummaryService.getCartsValue(customerNumber);
          this.cartQuoteSummaryService.getQuotesCounter(customerNumber);
          this.cartQuoteSummaryService.getQuotesValue(customerNumber);
        }
      }
    );
  }
}
